<template>
  <div class="table-search">
    <div class="search-area">
      <input
        v-model="value"
        ref="search"
        type="text"
        placeholder="搜索..."
        @keyup.enter="handleClick"
      />
      <div class="divider"></div>
      <i class="el-icon-search search-button" @click="handleClick"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value: this.defaultValue,
    }
  },
  mounted() {
    this.getFocus()
  },
  methods: {
    getFocus() {
      this.$refs["search"].focus()
    },
    handleClick() {
      this.$emit("handleSearch", this.value)
    },
  },
}
</script>

<style lang="scss">
$fontColor: #ccc;
$fontSize: 10px;
$backgroundColor: #34509d;
$border: 1px solid rgba(43, 57, 87, 0.4);
.table-search {
  height: 100%;
  // padding: 2px;
  width: 100%;
  // height: 100%;

  .search-area {
    position: relative;
    height: 1.25em;
    line-height: 1.25em;
    width: 100%;
    background-color: $backgroundColor;
    border-radius: 5px;
    border: $border;
    padding: 2px 0;
    padding-left: 5px;
    display: flex;
    align-items: center;
    border: $border;
    // justify-content: space-between;
    // padding-left: 5%;
    input {
      width: 85%;
      color: $fontColor;
      font-size: $fontSize;
      border: none;
      outline: none;
    }
  }
  .divider {
    display: inline-block;
    height: 100%;
    width: 1px;
    background-color: $fontColor;
    // border-left: $border;
    margin-right: 2px;
  }
  .search-button {
    padding: 0 2px;
    color: $fontColor;
    font-size: $fontSize;
    // position: absolute;
    // right: 5%;
    cursor: pointer;
    // top: 0;
  }
}
</style>
